import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/login/",
			name: "login",
			component: () => import("./views/LoginView/LoginView.vue"),
		},
		{
			path: "/logout/",
			name: "logout",
			component: () => import("./views/LogoutView/LogoutView.vue"),
		},
		{
			path: "/user/profile",
			name: "user-profile",
			component: () => import("./views/UserProfileView/UserProfileView.vue"),
		},
		{
			path: "/register-certifier/",
			name: "register-certifier",
			component: () => import("./views/RegisterCertifierAccountView/RegisterCertifierAccountView.vue"),
		},
		{
			path: "/certificates-dash/",
			name: "certificates-dash",
			component: () => import("./views/ViewRegistrationsDash/ViewRegistrationsDash.vue"),
		},
		{
			path: "/certificates-certifier-dash/",
			name: "certificates-certifier-dash",
			component: () => import("./views/ViewRegistrationsCertifierDash/ViewRegistrationsCertifierDash.vue"),
		},
		{
			path: "/register-nop-operation/",
			name: "register-nop-operation",
			component: () => import("./views/RegisterNOPOperationAccountView/RegisterNOPOperationAccountView.vue"),
		},
		{
			path: "/register-land/",
			name: "register-land",
			// route level code-splitting
			// this generates a separate chunk (create.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import("./views/CreateLandRegisterView/CreateLandRegisterView.vue"),
		},
		{
			path: "/transactions-dash",
			name: "transactions-dash",
			component: () =>
				import("./views/ViewRegistrationsAndTransactionsDash/ViewRegistrationsAndTransactionsDash.vue"),
		},
		{
			path: "/land-owner-dash/",
			name: "land-owner-dash",
			component: () => import("./views/LandOwnerDashboardView/LandOwnerDashboardView.vue"),
		},
		{
			path: "/view-land-record/:id",
			name: "view-land-record",
			component: () => import("./views/ViewLandRecordView/ViewLandRecordView.vue"),
		},
		{
			path: "/create-transaction/",
			name: "creatte-transaction",
			component: () => import("./views/CreateTransactionView/CreateTransactionView.vue"),
		},
		{
			path: "/view-transaction/:id",
			name: "view-transaction",
			component: () => import("./views/ViewTransactionView/ViewTransactionView.vue"),
		},
		{
			path: "/",
			name: "home",
			component: () => import("./views/CreateLandRegisterView/CreateLandRegisterView.vue"),
		},
		/*
			* IMPORTANT!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
			* THIS Route is a catch all-param
			* It is used to catch 404 pages.
			*
			* THIS RULE HAS TO BE THE LAST rule in our list!!!!
			* MAKESURE ITS THE LAST WHY AM I SCREAMING!!! HELLOOOO!O!O!O!O!O!O!OO!O!!!!
			*
		.*/
		{
			// will match everything
			path: "*",
			component: () => import("./views/ErrorViews/404.vue"),
		},
	],
});
